import React, { useEffect, useState } from 'react';
import { Slide } from '../../animation/animation';
import { State } from '../../reducers/history/interfaces/state.interface';

import styles from './progress.module.scss';

interface ProgressProps {
	active: boolean
	currentState: State
	total: number,
	quizProgress: number
}

export default function Progress({active, quizProgress}:ProgressProps) {
	const [ passed, setPassed ] = useState(0);

	useEffect(() => {
		var timer:number;

		function doCount(value:number) {
			timer = window.setTimeout(() => {
				if (passed == value) return;
				setPassed((value > passed) ? (passed + 1) : (passed - 1));
			}, 40);
		};

		doCount(quizProgress);

    return () => window.clearTimeout(timer);

	}, [quizProgress, passed])

	const style = {width: `${quizProgress || 0}%`};

	return (
		<Slide up duration={400} when={active}>
			<div className={styles.progress}>
				<div className={styles.track} style={style}>
					<h2 className={styles.header}>{passed}%</h2>
				</div>
			</div>
		</Slide>
	);
}